import { api } from '../../core/network/api';

/**
 * i18n endpoints. All public — the landing and the login screen are pre-auth
 * and still have to render in the visitor's tongue.
 *
 * The message catalogue itself is NOT fetched here: baselines are bundled JSON
 * and the admin override layer is fetched inside `i18n/index.ts` as part of
 * loading a locale. This module covers the rest.
 */

/**
 * Display FX rates from core's exchange-rate service (Frankfurter API).
 * Unwraps the `{ base, rates: { GBP: { rate, date } } }` envelope into a
 * flat `Record<string, number>` that `setRates()` expects.
 */
export const fetchRates = async (): Promise<Record<string, number>> => {
  const resp = await api.get<{
    base: string;
    rates: Record<string, { rate: number; date: string }>;
  }>('/rates');
  const flat: Record<string, number> = {};
  for (const [code, entry] of Object.entries(resp.rates)) {
    flat[code] = entry.rate;
  }
  return flat;
};

export interface I18nConfig {
  locales: string[];
  defaultLocale: string;
  currencies: string[];
  /** What the card is actually debited in — display currency is separate. */
  chargeCurrency: string;
}

/** What this install supports. Useful for a health check; the client has its own registry. */
export const fetchI18nConfig = () => api.get<I18nConfig>('/i18n/config');
